import { BeltConveyorAnimatic, BeltConveyorAnimaticProps } from '@crossnokaye/ux-animatics';

import {
  ANIMATIC_METRIC_1_LABEL_EXACT,
  ANIMATIC_METRIC_2_LABEL_EXACT,
  ANIMATIC_PRIMARY_LABEL_EXACT,
} from '@/features/equipment-browser/animatics/animatics.constants';
import { getLabel } from '@/features/equipment-browser/animatics/animatics.helpers';

import { AnimaticConfigProps } from './types';
import { ScaledAnimatic } from '../scaled-animatic';

export const AnimaticBeltConveyor = ({ config, labels, state, className }: AnimaticConfigProps) => {
  const beltConveyorConfig = config.specificAnimaticConfig?.beltConveyor;
  const primaryLabel = getLabel(labels, ANIMATIC_PRIMARY_LABEL_EXACT);
  const metric1Label = getLabel(labels, ANIMATIC_METRIC_1_LABEL_EXACT);
  const metric2Label = getLabel(labels, ANIMATIC_METRIC_2_LABEL_EXACT);

  return (
    <ScaledAnimatic className={className} scaleX={1} scaleY={1}>
      <BeltConveyorAnimatic
        flowDirection={
          beltConveyorConfig?.flowDirection as
            | BeltConveyorAnimaticProps['flowDirection']
            | undefined
        }
        incline={beltConveyorConfig?.incline ?? undefined}
        length={beltConveyorConfig?.length ?? undefined}
        metric1Label={metric1Label?.text}
        metric2Label={metric2Label?.text}
        primaryLabel={primaryLabel?.text}
        state={state}
      />
    </ScaledAnimatic>
  );
};
